import React, { useEffect, useState } from 'react';
import StatusHelper from '../../helpers/StatusHelper';
import { Link } from 'react-router-dom';
import Loading from '../Loading';
import { GridToolbarContainer, GridToolbarFilterButton, GridToolbarExport, GridToolbarDensitySelector } from '@mui/x-data-grid-premium';
import DateDisplay from '../DateDisplay';

import TranslatableDataGrid from '../shared/TranslatableDataGrid';
import { ThemeProvider } from '@mui/material/styles';
import StorefrontAdminTheme from '../shared/MUIStyles/StorefrontAdminTheme';
import Paper from '@mui/material/Paper';
import { useStorefrontAdministrationConfig } from '../../hooks/StorefrontAdministrationConfigContext';
import Box from '@mui/material/Box';


const Orders = (props) => {
    const { orders, fetching, localized } = props;
    const gridLocalized = useStorefrontAdministrationConfig().labels;
    const [rows, setRows] = useState([]);
    const theme = StorefrontAdminTheme;

    useEffect(() => {
        if (orders) {
            mapRows(orders);
        }
    }, [orders]);

    const customToolbar = () => {
        return (
            <GridToolbarContainer  >
                <Box sx={{ flexGrow: 1 }} />
                <GridToolbarFilterButton
                    slotProps={{
                        tooltip: { title: 'Filter list' }
                    }}
                    variant="outlined"
                    color="update"

                />
                <GridToolbarDensitySelector
                    slotProps={{
                        tooltip: { title: 'Change density' }
                    }}
                    variant="outlined"
                    color="update"
                />

                <GridToolbarExport
                    printOptions={{ disableToolbarButton: true }}
                    slotProps={{
                        tooltip: { title: 'Export data' }
                    }}
                    variant="outlined"
                    color="update"
                />
            </GridToolbarContainer>
        );
    }

    const mapRows = (orders) => {
        var rows = [];
        orders.forEach((order, index) => {
            rows.push({
                id: index,
                submittedOn: order.submittedOn,
                orderId: order.orderId,
                status: order.status,
                referenceNumber: order.referenceNumber,
                orderCompany: order.orderCompany,
                orderType: order.orderType
            });
        });
        setRows(rows);
    };

    const columns = [
        {
            field: 'orderId',
            headerAlign: 'left',
            headerName: localized.OrderNumber,
            flex: 1,
            renderCell: (params) => {
                return (
                    <Link to={`/order/${params.row.orderId}/${params.row.orderCompany}/${params.row.orderType}`}>
                        {`${params.row.orderId} ${params.row.orderType}`}
                    </Link>
                )
            }
        },
        {
            field: 'submittedOn',
            headerAlign: 'left',
            headerName: localized.DateOrdered,
            flex: 1,
            renderCell: (params) => {
                return(
                    <DateDisplay date={params.row.submittedOn} />
                )
            }
        },        
        {
            field: 'status',
            headerAlign: 'left',
            headerName: localized.Status,
            flex: 1,
            renderCell: (params) => {
                return (
                    <>{StatusHelper.formatOrderStatus(params.row.status, localized)}</>
                )
            }
        },
        {
            field: 'referenceNumber',
            headerAlign: 'left',
            headerName: localized.PONumber,
            flex:1
        }
    ];

    return (
        <>
            {
                fetching && <Loading type="brand" />
            }
            {
                !fetching && (gridLocalized && Object.keys(gridLocalized).length > 0) &&
                <>
                    <ThemeProvider theme={theme}>
                        <Paper sx={{
                            height: 700,
                            width: '100%'
                        }}>
                            <TranslatableDataGrid    
                                square={true }
                                rows={rows}
                                columns={columns}
                                insetToolbar={customToolbar}
                                labels={gridLocalized}
                            />
                        </Paper>
                    </ThemeProvider>
                </>
            }
        </>
    );
};

export default Orders;
